import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { InvestmentInstructionSubmission } from '../../../../models/submissions/investment-instruction-submission';
import { filter, map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-investment-instruction-submission-instruction-changes',
  templateUrl: './investment-instruction-submission-instruction-changes.component.html',
  styleUrls: ['./investment-instruction-submission-instruction-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentInstructionSubmissionInstructionChangesComponent implements OnChanges {
  @Input() submission!: InvestmentInstructionSubmission;
  @Input() descriptionText: string = '';

  private _submission = new BehaviorSubject<InvestmentInstructionSubmission | null>(null);
  public submission$ = this._submission.pipe(filter((sub): sub is InvestmentInstructionSubmission => sub !== null));

  public previousInvestmentInstructions$ = this.submission$.pipe(
    map(submission => submission.previous.investmentInstructions),
    map(instructions => instructions.slice().sort((a, b) => a.fundId - b.fundId))
  );

  public newInvestmentInstructions$ = this.submission$.pipe(
    map(submission => submission.new.investmentInstructions),
    map(instructions => instructions.slice().sort((a, b) => a.fundId - b.fundId))
  );

  public investmentInstructionsHaveChanged$ = this.newInvestmentInstructions$.pipe(
    map(newInstructions => !!newInstructions.length)
  );

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.submission) {
      this._submission.next(this.submission);
    }
  }
}
